
import { useState } from "react"
import { ChevronUp, ChevronDown } from "lucide-react"
import { useNavigate } from "react-router-dom"

const GroceryDepartments = () => {
  const departments = [
    {
      id: 1,
      name: "Produce",
      image: "/assets/produce1.jpg",
      route: '/departments/produce'
    },
    {
      id: 2,
      name: "Deli",
      image: "/assets/deli2.jpg",
      route: '/departments/deli'
    },
    {
      id: 3,
      name: "Liquor",
      image: "/assets/liquor.jpg",
      route: '/departments/liquor'
    },
  ]

  const [currentIndex, setCurrentIndex] = useState(0)
  const [isAnimating, setIsAnimating] = useState(false)
  const [animationDirection, setAnimationDirection] = useState("down")
  const navigate = useNavigate()

  const handleNext = () => {
    if (isAnimating) return
    setAnimationDirection("down")
    setIsAnimating(true)
    setTimeout(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % departments.length)
      setIsAnimating(false)
    }, 300) // Sped up animation from 800ms to 300ms
  }

  const handlePrev = () => {
    if (isAnimating) return
    setAnimationDirection("up")
    setIsAnimating(true)
    setTimeout(() => {
      setCurrentIndex((prevIndex) => (prevIndex - 1 + departments.length) % departments.length)
      setIsAnimating(false)
    }, 300) // Sped up animation from 800ms to 300ms
  }

  const currentDepartment = departments[currentIndex]

  const handleClick = (path) => {
    navigate(path)
  }

  return (
    
    <div className="w-full max-w-6xl mx-auto p-6 bg-background">
      <h1 className="text-4xl font-bold text-gray-800 mb-4 p-8 flex justify-center mt-10">
        Featured Departments
      </h1>
      <div className="cursor-pointer rounded-lg border bg-white  shadow group overflow-hidden bg-card border-border hover:shadow-lg transition-all duration-500" 
      onClick={() => handleClick(currentDepartment.route)}>
        <div
          className={`relative transition-transform duration-300 ease-in-out ${
            isAnimating
              ? animationDirection === "up"
                ? "transform translate-y-2 opacity-70" // Reduced movement from translate-y-8 to translate-y-2
                : "transform -translate-y-2 opacity-70" // Reduced movement from -translate-y-8 to -translate-y-2
              : "transform translate-y-0 opacity-100"
          }`}
        >
          <div className="relative w-full overflow-hidden">
            <img
              src={currentDepartment.image || "/placeholder.svg"}
              alt={currentDepartment.name}
              className="w-full h-96 object-cover transition-all duration-300 group-hover:scale-105" // Increased height from h-80 to h-96
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

            <div
              className="absolute bottom-0 left-0 right-0 p-6 pt-12"
              style={{
                background: "linear-gradient(to top, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.6) 0%, transparent 100%)",
              }}
            >
              <h3 className="text-4xl font-bold text-white">{currentDepartment.name}</h3>
            </div>
          </div>
        </div>
      </div>

      <div className="flex justify-center items-center mt-6 space-x-4">
        <button
          onClick={handlePrev}
          className="bg-primary/80 hover:bg-primary text-primary-foreground rounded-full p-3 transition-all duration-200 hover:scale-110"
        >
          <ChevronUp className="w-6 h-6" />
        </button>

        <button
          onClick={handleNext}
          className="bg-primary/80 hover:bg-primary text-primary-foreground rounded-full p-3 transition-all duration-200 hover:scale-110"
        >
          <ChevronDown className="w-6 h-6" />
        </button>
      </div>

      <div className="flex justify-center mt-4 space-x-2">
        {departments.map((_, index) => (
          <button
            key={index}
            onClick={() => {
              if (!isAnimating) {
                setAnimationDirection("down")
                setIsAnimating(true)
                setTimeout(() => {
                  setCurrentIndex(index)
                  setIsAnimating(false)
                }, 300) // Updated timeout to match new animation duration
              }
            }}
            className={`w-3 h-3 rounded-full transition-all duration-300 ${
              index === currentIndex ? "bg-primary" : "bg-muted hover:bg-muted-foreground/50"
            }`}
          />
        ))}
      </div>
    </div>
  )
}

export default GroceryDepartments
